<template>
    <div>
        <iframe
            v-if="clicked"
            :src="url"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            class="w-full h-80 mx-auto"
            frameborder="0"
            allowFullScreen
        ></iframe>

        <div v-else
             @click="clicked = true"
             class="bg-cover bg-center cursor-pointer flex items-center justify-center max-w-full w-full mx-auto h-80 rounded-lg text-white" :style="coverStyle()">
            <svg-icon icon="play-circle" class="w-16 h-16 transition-all duration-150 ease-in-out hover:scale-105"></svg-icon>
        </div>
    </div>
</template>
<script>
import SvgIcon from "./SvgIcon.vue";

export default {
    components: {SvgIcon},
    props: ['url', 'cover'],
    data() {
        return {
            clicked: false
        };
    },
    methods: {
        coverStyle() {
            return {backgroundImage: `url(${this.cover})`};
        }
    }

}
</script>